import { getFalSteps } from "@features/vessel-call/create/utils";
import ReviewFal1 from "@features/vessel-call/vessel-call-status/VesselCallDetails/ImoFalReview/ReviewFal1";
import ReviewFal2 from "@features/vessel-call/vessel-call-status/VesselCallDetails/ImoFalReview/ReviewFal2";
import ReviewFal3 from "@features/vessel-call/vessel-call-status/VesselCallDetails/ImoFalReview/ReviewFal3";
import ReviewFal4 from "@features/vessel-call/vessel-call-status/VesselCallDetails/ImoFalReview/ReviewFal4";
import ReviewFal5 from "@features/vessel-call/vessel-call-status/VesselCallDetails/ImoFalReview/ReviewFal5";
import ReviewFal6 from "@features/vessel-call/vessel-call-status/VesselCallDetails/ImoFalReview/ReviewFal6";
import ReviewFal7 from "@features/vessel-call/vessel-call-status/VesselCallDetails/ImoFalReview/ReviewFal7";

export function getImoFalPreviewData() {
  const steps = getFalSteps();
  const components = [
    ReviewFal1,
    ReviewFal2,
    ReviewFal3,
    ReviewFal4,
    ReviewFal5,
    ReviewFal6,
    ReviewFal7,
  ];
  const testIds = {
    tabs: "imo-fal-preview-stepper-tabs",
    panel: (idx: number) => `imo-fal-preview-panel-${idx + 1}`,
  } as const;
  return { steps, components, testIds };
}

export type ImoFalPreviewData = ReturnType<typeof getImoFalPreviewData>;
